import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const initHeadingAnimations = () => {
  // Select all headings that need animation
  const headings = document.querySelectorAll('.js-animate-text');

  headings.forEach(heading => {
    const text = heading.textContent;
    heading.innerHTML = '';
    
    // Split text into words
    const words = text.split(' ');
    
    // Create word spans
    words.forEach((word, wordIndex) => {
      // Create word span
      const wordSpan = document.createElement('span');
      wordSpan.style.display = 'inline-block';
      wordSpan.style.opacity = '0';
      wordSpan.style.transform = 'translateY(20px)';
      wordSpan.textContent = word;
      
      heading.appendChild(wordSpan);
      
      // Add space after each word except the last one
      if (wordIndex < words.length - 1) {
        const spaceSpan = document.createElement('span');
        spaceSpan.textContent = ' ';
        heading.appendChild(spaceSpan);
      }
      
      // Animate each word
      gsap.to(wordSpan, {
        scrollTrigger: {
          trigger: heading,
          start: 'top 80%',
          toggleActions: 'play none none reverse'
        },
        opacity: 1,
        y: 0,
        duration: 0.8,
        delay: wordIndex * 0.03,
        ease: 'power2.out'
      });
    });
  });

  // Add background color animation and parallax effect for page hero
  const pageHero = document.querySelector('.c-page-hero');
  if (pageHero) {
    // Background color animation
    gsap.to(pageHero, {
      scrollTrigger: {
        trigger: pageHero,
        start: 'top top',
        end: 'bottom top',
        scrub: true
      },
      backgroundColor: '#0b34c6', // Darker blue color
      ease: 'none'
    });

    // Parallax effect for hero content
    const heroContent = pageHero.querySelector('.c-page-hero__content');
    if (heroContent) {
      gsap.to(heroContent, {
        scrollTrigger: {
          trigger: pageHero,
          start: 'top top',
          end: 'bottom top',
          scrub: true
        },
        y: '-150%',
        opacity: 0,
        ease: 'none'
      });
    }
  }
};

export const initCardAnimations = () => {
  // Select all cards in g-cards
  const cards = document.querySelectorAll('.g-cards .c-card');
  
  if (cards.length) {
    // First set initial state
    gsap.set(cards, {
      y: 50,
      opacity: 0
    });

    // Then animate to final state
    gsap.to(cards, {
      scrollTrigger: {
        trigger: '.g-cards',
        start: 'top 90%', // Changed from 80% to 90% to make cards appear earlier
        toggleActions: 'play none none reverse',
        once: true // Only play the animation once
      },
      y: 0,
      opacity: 1,
      duration: 0.8,
      stagger: 0.1,
      ease: 'expo.out',
      clearProps: 'all' // Clear all properties after animation
    });
  }
}; 